<col [style.width]="width" [style.minWidth]="width" *ngFor="let width of listOfColWidth" />
<thead class="ant-table-thead" *ngIf="theadTemplate">
  <ng-template [ngTemplateOutlet]="theadTemplate"></ng-template>
</thead>
<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
<ng-content></ng-content>
